import { put, takeLatest, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
// import uniqid from 'uniqid';
import request from 'utils/request';
import { CHANGE_CURRENT_PROJECT_START, GET_TEAMS_ONLY_TOKEN } from './constants';
import { changeCurrentProjectSuccess, getTeamsOnlyToken } from './actions';
import triggerNotification from 'utils/triggerNotification';
import convertErrorMsg from 'utils/convertErrorMsg';
import { NOTIFICATION } from 'common/constants';
import queryString from 'query-string';
import localStorageTemplates from 'common/local-storage-templates';
import routeTemplates from 'common/route-templates';

export function* setCurrentProject({ payload, metadata }) {
  yield put(changeCurrentProjectSuccess(payload));
  if (metadata.redirect) yield put(push(metadata.url));
}

export function* getTeamsOnlyTokenStart({ metadata }) {
  const { setAuthenticated, payload } = metadata;
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/login/msteams',
      config: {
        data: {
          ...payload,
        },
      },
    });
    const { data } = response;
    yield put(getTeamsOnlyToken.success({ data }));
    setAuthenticated(data.token);
    localStorage.setItem(localStorageTemplates.teamsOnlyToken, true);
    const searchParams = queryString.parse(window.location.search);
    const redirectUrl = searchParams.redirectUrl;
    yield put(push((redirectUrl && decodeURIComponent(redirectUrl)) || routeTemplates.home));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(getTeamsOnlyToken.error(errorMessage));
  }
}

export default function* app() {
  yield takeLatest(CHANGE_CURRENT_PROJECT_START, setCurrentProject);
  yield takeLatest(GET_TEAMS_ONLY_TOKEN.START, getTeamsOnlyTokenStart);
}
